import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Icon from '../common/icons/Icon';

class GolfSchoolsListPage extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    schools: PropTypes.object,
  };

  render() {
    const { schools } = this.props;

    return (
      <div className="admin-paper">
        <div className="admin-paper__header">
          <h3>Golf Schools</h3>
        </div>
        <ul className="admin-paper__list">
          {schools.get('data').size ? (
            schools.get('data').map(school => (
              <li key={`school-${school.get('id')}`}>
                <div className="admin-paper__list__title">{school.get('name')}</div>
                <div className="admin-paper__list__actions">
                  <Link className="admin-paper__list__link" to={`/golf-schools/${school.get('id')}`}>
                    Go to School <Icon icon="Arrow" />
                  </Link>
                </div>
              </li>
            ))
          ) : (
            <div className="admin-paper__no-content">There are currently no schools</div>
          )}
        </ul>
      </div>
    );
  }
}

export default connect(state => ({
  schools: state.golfSchools.schools,
}))(GolfSchoolsListPage);



// WEBPACK FOOTER //
// ./src/golf-schools/GolfSchoolsListPage.js